import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../../App.css';
import {
  getNextDay,
  checkIsReschedule,
  tokenIsValid,
  getToken,
  sessionStorageGetItem,
  sessionStorageSetItem,
} from '../Function';
import { LoadingScreenModal } from '../LoadingScreenModal';
import { SelectDepartureAndReturn } from '../SelectDepartureAndReturn';
import { SelectDepartureMultiModal } from '../SelectDepartureMultiModal';

// import Checkout from '../Checkout';
import { SelectDepartureHeader } from '../SelectDepartureHeader';

import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import axios from 'axios';

function PickDepart(props) {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  // const checkReschedule = checkIsReschedule();

  //remove checkout expiry timestamp
  sessionStorage.removeItem('checkout_expiry_ts');

  const [origin_data, setOriginData] = useState(() => {
    const stored = sessionStorageGetItem('Origin_data');
    return stored ? JSON.parse(stored) : null;
  });

  const [destination_data, setDestinationData] = useState(() => {
    const stored = sessionStorageGetItem('Destination_data');
    return stored ? JSON.parse(stored) : null;
  });

  const [searchParams, setSearchParams] = useSearchParams();

  const [data, setData] = useState(null);
  const [dateDetail, setDateDetail] = useState(null);
  // const [multiModalData, setMultiModalData] = useState(null);

  // const currency = checkCurrency();
  //default MYR
  const currency = localStorage.getItem('currency');

  const origin_subplace_unique_shortname = searchParams.get('depart');
  const destination_subplace_unique_shortname = searchParams.get('destination');

  const showBanner =
    (origin_subplace_unique_shortname === 'jbsentral' ||
      origin_subplace_unique_shortname === 'senaiinternationalairport') &&
    (destination_subplace_unique_shortname === 'senaiinternationalairport' ||
      destination_subplace_unique_shortname === 'jbsentral');

  var data_depart_date;

  if (searchParams.get('depart_date') === 'today') {
    // console.log('today');
    // Get today's date in yyyy-mm-dd format
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so +1
    const dd = String(today.getDate()).padStart(2, '0');

    // Assign the formatted date to data_depart_date
    data_depart_date = `${yyyy}-${mm}-${dd}`;
  } else {
    data_depart_date =
      searchParams.get('depart_date') != null
        ? searchParams.get('depart_date')
        : origin_data.departdate;
  }

  const data_return_date =
    searchParams.get('return_date') != null
      ? searchParams.get('return_date')
      : origin_data.returndate;
  const data_passenger =
    searchParams.get('passenger') != null
      ? searchParams.get('passenger')
      : origin_data.passenger;

  const [selected_date, setSelectedDate] = useState(data_depart_date);
  const [loading, setLoading] = useState(true);

  // function checkCurrency() {
  // 	if (sessionStorageGetItem('Origin_data') != null) {
  // 		const origin_data = JSON.parse(sessionStorageGetItem('Origin_data'));
  // 		// console.log(origin_data)
  // 		if (origin_data) {
  // 			if (origin_data.placeid === 4) {
  // 				return 'SGD';
  // 			}
  // 		}
  // 		return 'MYR';
  // 	}
  // }

  // let getTripsUrl = `${SERVER_URL}/me/get/trips/${getNextDay(selected_date,-5)}/${getNextDay(selected_date,5)}/${currency}/${selected_date}/${destination_subplace_unique_shortname}/null/${origin_subplace_unique_shortname}/${data_passenger}`
  let getTripsUrl = `${SERVER_URL}/me/get/trips/${getNextDay(
    selected_date,
    -5,
  )}/${getNextDay(
    selected_date,
    5,
  )}/${currency}/${selected_date}/${origin_subplace_unique_shortname}/null/${destination_subplace_unique_shortname}/${data_passenger}`;

  // if (checkReschedule === true) {
  // 	const origin_data =
  // 		sessionStorageGetItem('Origin_data') != null
  // 			? (sessionStorageGetItem('Origin_data'))
  // 			: null;
  // 	const destination_data =
  // 		sessionStorageGetItem('Destination_data') != null
  // 			? (sessionStorageGetItem('Destination_data'))
  // 			: null;

  // 	getTripsUrl = `${SERVER_URL}/me/get/trips/${getNextDay(
  // 		selected_date,
  // 		-5
  // 	)}/${getNextDay(selected_date, 5)}/${currency}/${selected_date}/${origin_data.subplaceuniqueshortname
  // 		}/null/${destination_data.subplaceuniqueshortname}/${origin_data.passenger
  // 		}`;
  // }

  useEffect(() => {
    const handlePageShow = () => {
      sessionStorage.removeItem('returnData');
      sessionStorage.removeItem('departData');
      sessionStorage.removeItem('return_TripKey');
      sessionStorage.removeItem('depart_TripKey');
      sessionStorage.removeItem('departDataMultiModal');
      sessionStorage.removeItem('busFare');
      sessionStorage.removeItem('departBusFare');
      sessionStorage.removeItem('returnBusFare');

      const elements = document.querySelectorAll('.trips_button');
      elements.forEach((el) => {
        el.innerHTML = 'Select';
        el.classList.remove('selected');
      });
    };

    // Run on first mount
    handlePageShow();
    // Listen for when coming back
    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);

  const handleSelectedDateCallBack = (selected_date) => {
    setSelectedDate(selected_date);
  };

  useEffect(() => {
    setLoading(true);
    const getTripsData = async () => {
      try {
        const response = await fetch(getTripsUrl, {
          method: 'POST',
          headers: {
            Authorization: getToken(),
          },
        });
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`,
          );
        }
        let tripsData = await response.json();

        // console.log(tripsData)

        setData(tripsData.trips);
        setDateDetail(tripsData.tripsummary);
        // setMultiModalData(tripsData.trips?.multimodaltrips);

        // if (checkReschedule === false) {
        // 	setOriginData(tripsData.origin);
        // 	setDestinationData(tripsData.destination);

        // sessionStorageSetItem(
        // 	'Origin_data',
        // 	(tripsData.origin)
        // );
        // sessionStorageSetItem(
        // 	'Destination_data',
        // 	(tripsData.destination)
        // );
        // }
        // if(depart.SubPlaceId !== tripsData.origin.SubPlaceId || destination.SubPlaceId !== tripsData.destination.SubPlaceId) {
        //     window.location.reload();
        // }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    tokenIsValid();

    if (getToken() != null) {
      if (sessionStorageGetItem('Origin_data') != null) {
        const origin_data = sessionStorageGetItem('Origin_data');
        // sessionStorageSetItem('currency', JSON.stringify('MYR'));
      }

      getTripsData();
    }
  }, [currency, selected_date, getToken()]);

  const getOrigin = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/me/get/subplaces/search/${origin_subplace_unique_shortname}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              sessionStorageGetItem('token'),
            )}`,
          },
        },
      );

      for (const data of response.data) {
        if (origin_subplace_unique_shortname === data.placeuniqueshortname) {
          const d = {
            placeid: data.placeid,
            placename: data.placename,
            placedisplayname: data.placedisplayname || data.placename,
            placeuniqueshortname: data.placeuniqueshortname,

            subplaceid: null,
            subplacename: null,
            subplaceuniqueshortname: null,
            subplacedisplayname1: null,
            subplacedisplayname: null,
          };

          sessionStorageSetItem('Origin_data', JSON.stringify(d));
          setOriginData(d);
        } else {
          if (
            origin_subplace_unique_shortname === data.subplaceuniqueshortname
          ) {
            const d = {
              placeid: data.placeid,
              placename: data.placename,
              placedisplayname: data.placedisplayname || data.placename,
              placeuniqueshortname: data.placeuniqueshortname,

              subplaceid: data.subplaceid,
              subplacename: data.subplacename,
              subplaceuniqueshortname: data.subplaceuniqueshortname,
              subplacedisplayname1: data.subplacedisplayname1,
              subplacedisplayname: data.subplacedisplayname,
            };

            sessionStorageSetItem('Origin_data', JSON.stringify(d));
            setOriginData(d);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDestination = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/me/get/subplaces/search/${destination_subplace_unique_shortname}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              sessionStorageGetItem('token'),
            )}`,
          },
        },
      );

      for (const data of response.data) {
        if (
          destination_subplace_unique_shortname === data.placeuniqueshortname
        ) {
          const d = {
            placeid: data.placeid,
            placename: data.placename,
            placedisplayname: data.placedisplayname || data.placename,
            placeuniqueshortname: data.placeuniqueshortname,

            subplaceid: null,
            subplacename: null,
            subplaceuniqueshortname: null,
            subplacedisplayname1: null,
            subplacedisplayname: null,
          };

          sessionStorageSetItem('Destination_data', JSON.stringify(d));
          setDestinationData(d);
        } else {
          if (
            destination_subplace_unique_shortname ===
            data.subplaceuniqueshortname
          ) {
            const d = {
              placeid: data.placeid,
              placename: data.placename || data.placename,
              placedisplayname: data.placedisplayname,
              placeuniqueshortname: data.placeuniqueshortname,

              subplaceid: data.subplaceid,
              subplacename: data.subplacename,
              subplaceuniqueshortname: data.subplaceuniqueshortname,
              subplacedisplayname1: data.subplacedisplayname1,
              subplacedisplayname: data.subplacedisplayname,
            };

            sessionStorageSetItem('Destination_data', JSON.stringify(d));
            setDestinationData(d);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const getData = async () => {
      await Promise.all([getDestination(), getOrigin()]);
    };

    getData();
  }, []);

  if (origin_data !== null && destination_data !== null) {
    return (
      <>
        {loading && (
          <div className='center'>
            <LoadingScreenModal />
          </div>
        )}
        <SelectDepartureHeader
          subplace_data={props.subplace_data}
          depart_data={origin_data}
          destination_data={destination_data}
          date_depart={data_depart_date}
          date_return={data_return_date}
          passenger={data_passenger}
          edit_search='Edit Search'
        ></SelectDepartureHeader>

        {
          <>
            <Container>
              <Row>
                <Col xs={12} sm={12} style={{ paddingTop: '20px' }}>
                  {/* {showBanner && (
                    <img
                      src='images/aa1-banner-latest.png'
                      alt='AA1 Banner'
                      style={{ width: '100%', cursor: 'pointer' }}
                      onClick={() =>
                        window.open(
                          'https://www.causewaylink.com.my/help/knowledge-base/terms-and-conditions-for-aa1tofly/',
                          '_blank'
                        )
                      }
                    />
                  )} */}
                </Col>
              </Row>
            </Container>

            <SelectDepartureAndReturn
              title='Departure'
              link='/pickReturn'
              depart={origin_data}
              destination={destination_data}
              handleSelectedDateCallBack={handleSelectedDateCallBack}
              data={data}
              dateDetail={dateDetail}
              // origin_subplace_unique_shortname={
              // 	origin_subplace_unique_shortname
              // }
              // destination_subplace_unique_shortname={
              // 	destination_subplace_unique_shortname
              // }
              date_depart={data_depart_date}
              date_return={data_return_date}
              passenger={data_passenger}
            />

            {/* 

						{multiModalData && multiModalData.length > 1 ? (
							<SelectDepartureMultiModal
								title='Departure'
								link='/pickReturn'
								depart={origin_data}
								destination={destination_data}
								handleSelectedDateCallBack={handleSelectedDateCallBack}
								data={data}
								dateDetail={dateDetail}
								multiModalData={multiModalData}
								origin_subplace_unique_shortname={
									origin_subplace_unique_shortname
								}
								destination_subplace_unique_shortname={
									destination_subplace_unique_shortname
								}
								date_depart={data_depart_date}
								date_return={data_return_date}
								passenger={data_passenger}
							/>
						) : (
							<SelectDepartureAndReturn
								title='Departure'
								link='/pickReturn'
								depart={origin_data}
								destination={destination_data}
								handleSelectedDateCallBack={handleSelectedDateCallBack}
								data={data}
								dateDetail={dateDetail}
								origin_subplace_unique_shortname={
									origin_subplace_unique_shortname
								}
								destination_subplace_unique_shortname={
									destination_subplace_unique_shortname
								}
								date_depart={data_depart_date}
								date_return={data_return_date}
								passenger={data_passenger}
							/>
						)} */}
          </>
        }
      </>
    );
  }
}

export default PickDepart;
